// extracted by mini-css-extract-plugin
export var container = "Testimonial-module--container--f5e32";
export var frame = "Testimonial-module--frame--c4442";
export var name = "Testimonial-module--name--84afc";
export var pic = "Testimonial-module--pic--321ae";
export var position = "Testimonial-module--position--22126";
export var quote = "Testimonial-module--quote--88027";